"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("@react-mdc/base");
var constants_1 = require("./constants");
exports.CLASS_NAME = constants_1.BASE_CLASS_NAME + "__media-item";
function classNameForSize(size) {
    switch (size) {
        case 1.5:
            return exports.CLASS_NAME + "--1dot5x";
        case 2:
            return exports.CLASS_NAME + "--2x";
        case 3:
            return exports.CLASS_NAME + "--3x";
        default:
            throw new TypeError("Invalid size: " + size);
    }
}
exports.classNameForSize = classNameForSize;
/**
 * Media item component
 */
var Meta = (function (_super) {
    __extends(Meta, _super);
    function Meta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Meta.prototype.renderBaseClassName = function () {
        return exports.CLASS_NAME;
    };
    Meta.prototype.renderClassValues = function () {
        return [
            this.props.size == null ? null : classNameForSize(this.props.size),
        ];
    };
    return Meta;
}(base_1.ClassNameMetaBase));
exports.Meta = Meta;
var MediaItem = (function (_super) {
    __extends(MediaItem, _super);
    function MediaItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaItem.prototype.getMetaComponent = function () {
        return Meta;
    };
    MediaItem.prototype.getMetaPropNames = function () {
        return [
            "className",
            "size",
        ];
    };
    MediaItem.prototype.getChildComponent = function () {
        return "img";
    };
    MediaItem.Meta = Meta;
    return MediaItem;
}(base_1.DefaultComponentBase));
exports.default = MediaItem;
//# sourceMappingURL=MediaItem.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/card/lib/MediaItem.js
// module id = ./node_modules/@react-mdc/card/lib/MediaItem.js
// module chunks = 1